// tells if the Oldtime has elapse 1 hour - (60 * 60 * 1000)
// returns true if checkTime is expired
// return false if checkTime is not expired

export default checkTime => {
  return !((new Date().getTime() - checkTime) / (60 * 60 * 1000) < 1)
}
